/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import PagesContainer from "src/components/shared/molecules/PagesContainer";
import NoRecordFound from "src/components/shared/molecules/NoRecordFound";
import ModalLayout from "src/components/shared/atoms/modalLayout";
import useStyles from "./Styles";

interface ModalProps {
  setOpenModal: (a: () => void) => void;
  source: string;
  data: any;
}

interface ModalRefType {
  handleOpen: () => void;
}

const PendingChatListModal: React.FC<ModalProps> = ({
  setOpenModal,
  source,
  data,
}) => {
  const { classes } = useStyles();

  const modalRef = useRef<ModalRefType | null>(null);
  const [filteredData, setFilteredData] = useState<any[]>([]);

  // ✅ Register openModal only once when modalRef is ready
  useEffect(() => {
    setOpenModal(() => () => modalRef.current?.handleOpen());
  }, [setOpenModal]);

  useEffect(() => {
    if (data && source) {
      const filtered = data.filter(
        (item: any) => item.source === source.toLowerCase(),
      );
      setFilteredData(filtered);
    } else {
      setFilteredData([]);
    }
  }, [data, source]);

  const style = {
    maxWidth: "555px",
    minHeight: "400px",
    width: "100%",
  };

  const sourceColors: Record<string, string> = {
    facebook: "#1877F2",
    whatsapp: "#60D669",
    instagram: "#B336AA",
    chatbot: "#4D1277",
  };

  return (
    <ModalLayout
      headerText={
        <Box className={classes.headerTextBox}>
          <Typography className={classes.headerText}>
            {/* {source} Pending Chats */}
            {source === "facebook_comments"
              ? "Facebook Pending Comments Counts"
              : `${source} Pending Chats`}
          </Typography>
          <Box
            className={classes.headerCount}
            sx={{
              backgroundColor: sourceColors[source.toLowerCase()] || "#999",
            }}
          >
            {filteredData.length}
          </Box>
        </Box>
      }
      ref={modalRef}
      modalCustomStyle={style}
    >
      <Box className={classes.contentBox}>
        {filteredData.length === 0 ? (
          <NoRecordFound />
        ) : (
          <PagesContainer
            title="Pending Chats"
            dataList={filteredData}
            chatTitle="pending"
          />
        )}
      </Box>
    </ModalLayout>
  );
};

export default PendingChatListModal;
